<template>
  <div id="app" :class="barOnTop ? 'top' : ''">
    <SearchBar v-if="showSearch" />
    <TaskBar />
    <MediaGrid v-if="user" :uid="user.uid" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SearchBar from './components/SearchBar.vue'
import TaskBar from './components/TaskBar.vue'
import MediaGrid from './components/MediaGrid.vue'

export default {
  name: "app",
  data() {
    return {
      searchListener: null,
      showSearch: false
    }
  },
  computed: {
    ...mapState([
      'user',
      'barOnTop'
    ])
  },
  components: {
    SearchBar,
    TaskBar,
    MediaGrid
  },
  mounted() {
    this.addSearchListener()
  },
  destroyed() {
    this.removeSearchListener()
  },
  methods: {
    addSearchListener() {
      this.searchListener = window.addEventListener('keyup', (e) => {
        if (e.key === 's') {
          this.showSearch = true
        } else if (e.key === 'Escape') {
          this.showSearch = false
          this.$store.commit('setQuery', '')
        }
      })
    },
    removeSearchListener() {
      window.removeEventListener('keyup', this.searchListener)
    }
  }
};
</script>

<style lang="stylus">
@import './assets/styles/global'
</style>
